import React from 'react';
import './ChestOpeningHistoryItem.css';
import PageButton from '../elements/PageButton/PageButton';
import {getChestDisplayName} from '../../utils/inventory/getChestDisplayName';
import {getChestIconPath} from '../../utils/inventory/getChestIconPath';
import {resolveChestOpeningRewardDisplay} from '../../utils/chestOpenings/resolveChestOpeningRewardDisplay';
import {formatMatchDate} from '../../utils/date/formatMatchDate';

function ChestOpeningHistoryItem({opening, showUserName, onClick, pageId, buttonId}) {
  const chestName = getChestDisplayName(opening.chestId);
  const chestIconPath = getChestIconPath(opening.chestId);
  const {
    name: rewardName,
    iconPath: rewardIconPath,
    isNumens,
    isCrystals
  } = resolveChestOpeningRewardDisplay(opening.reward);

  const content = (
    <>
      <img className="chest-opening-history-icon" src={chestIconPath} alt={chestName} title={chestName}/>
      <div className="chest-opening-history-info">
        <span className="chest-opening-history-name">{chestName}</span>
        {showUserName && opening.userName && (
          <span className="chest-opening-history-user-name">{opening.userName}</span>
        )}
      </div>
      <div className="chest-opening-history-reward">
        <span
          className={`chest-opening-history-reward-name ${isNumens ? 'text-coins' : isCrystals ? 'text-crystals' : ''}`}
        >
          {rewardName}
        </span>
        {rewardIconPath && (
          <img className="chest-opening-history-reward-icon" src={rewardIconPath} alt={rewardName} title={rewardName}/>
        )}
      </div>
      <span className="chest-opening-history-date">{formatMatchDate(opening.createdAt)}</span>
    </>
  );

  if (onClick) {
    return (
      <PageButton
        className="chest-opening-history-item chest-opening-history-item_clickable"
        onClick={onClick}
        pageId={pageId}
        buttonId={buttonId}
      >
        {content}
      </PageButton>
    );
  }

  return (
    <div className="chest-opening-history-item">
      {content}
    </div>
  );
}

export default ChestOpeningHistoryItem;
